import { supabase } from './supabase';

const DEFAULT_VAPID_PUBLIC_KEY = 'BBZkliMe7aFqtW1M0PNgqq-LAwMQMUR2wWeVXI_pbJYb8efa8F-FokWv06cpLhghuy_zb98eEkDWz6WrIVsDK6M';
const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || DEFAULT_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(char => char.charCodeAt(0)));
}

export function pushDisponivel() {
  return Boolean(
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window &&
    VAPID_PUBLIC_KEY
  );
}

export function statusPermissaoPush() {
  if (typeof Notification === 'undefined') return 'unsupported';
  return Notification.permission;
}

export async function ativarNotificacoesPush() {
  if (!pushDisponivel()) {
    return { ok: false, error: 'Este navegador não permite notificações push para este app.' };
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    return { ok: false, error: 'Permissão de notificação não autorizada.' };
  }

  const registration = await navigator.serviceWorker.register('/push-worker.js');
  const existente = await registration.pushManager.getSubscription();
  const subscription = existente || await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
  });

  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    return { ok: false, error: 'Faça login novamente para ativar as notificações.' };
  }

  const res = await fetch('/.netlify/functions/push-subscribe', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ subscription }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    return { ok: false, error: body.error || 'Não foi possível salvar a permissão.' };
  }
  return { ok: true };
}
